import type { Me } from '../../api';

/** Поля /auth/me, що додала міграція 029 (тенанти й партнерські компанії). */
type TenantMe = Me & { is_partner_company?: boolean };

/**
 * Назва партнерської компанії для бренду в CRM. Для VIA DOMUM (і поки /auth/me не знає про тенанти) — null:
 * тоді лишається звичайний знак VIA DOMUM.
 */
export function partnerCompanyName(me: Me | null | undefined): string | null {
  const m = me as TenantMe | null | undefined;
  if (!m?.is_partner_company) return null;
  const name = m.organization?.name?.trim();
  return name || null;
}
